import styled, { css } from "styled-components";

export const TableWrapper = styled.div`
  margin-right: 42px;
  margin-left: 38px;

  table {
    background-color: ${({theme}) => theme.colors.surface.surfaceContainer};
  }

  thead,
  tbody tr {
    display: table;
    width: calc(100% - 3px);
    table-layout: fixed;
  }

  thead {
    tr th:first-child {
      width: 85px;
    }

    tr th:last-child {
      width: 48px;
    }
  }
  
  tbody {
    display: block;
    max-height: calc(100vh - 366px);
    overflow-y: auto;
    
    tr td:first-child {
      width: 85px;
    }

    tr td:last-child {
      width: 48px;
    }
  }
`;

interface IDisciplineItem {
  error?: boolean;
}

export const DisciplineItem = styled.div<IDisciplineItem>`
  display: flex;
  align-items: center;
  user-select: none;
  height: 51px;
  cursor: pointer;

  .disciplineItemText {
    color: ${({theme}) => theme.colors.surface.onSurface};
    padding: 0 18px;
  }

  .dotWrapper {
    margin-right: 18px;
  }

  ${({error}) => error && css`
    cursor: default;
    
    .disciplineItemText {
      color: ${({theme}) => theme.colors.danger.danger};
      cursor: pointer;
    }
  `}
`;

export const ActionColumn = styled.div`
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  .iconAction {
    cursor: pointer;
  }
`;
